/**
 *
 * Asynchronously loads the component for WorkflowManager
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
